import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import IconSvg from "@/components/IconSvg.vue";
import { dataMapper } from "@/services/store/modules/data/store";
const UiMappers = Vue.extend({});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["videoLink"]),
    },
});
let VideoMain = class VideoMain extends Mixins(UiMappers, DataMappers) {
    openVideo() {
        window.open(this.videoLink, "_blank");
    }
};
VideoMain = __decorate([
    Component({
        components: {
            IconSvg,
        },
    })
], VideoMain);
export default VideoMain;
